<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div
        v-ripple
        class="d-flex justify-space-between align-center py-2"
        :class="$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-4'"
        :style="
          hover
            ? `color: #579FA75C; background-color: ${
                layout == 'portal' ? '#579FA71F' : 'var(--v-primary-opacity-12)'
              }; cursor: pointer;`
            : ''
        "
        @click="$emit('showOrderDetails', order)"
      >
        <div class="d-flex">
          <div
            class="pt-2 pr-3 profile__container--content__orderhistory--price"
          >
            <v-icon :color="iconColor">{{icon}}</v-icon>
          </div>
          <div>
            <p
              class="font-weight-bold mb-0"
              :style="hover ? 'color: var(--v-primary-base)' : ''"
            >
              {{ getDate(order.date)
              }}<span class="font-weight-regular text--secondary">
                ({{ description }})</span
              >
            </p>
            <p
              class="mb-0"
              :style="hover ? 'color: var(--v-primary-base)' : ''"
            >
              {{ order.siteName }}
            </p>
          </div>
        </div>
        <div class="d-flex profile__container--content__orderhistory--price">
          <p
            class="mb-0 pr-2"
            :class="isPardoned ? 'text-decoration-line-through' : ''"
            :style="
              isCancelled
                ? hover
                  ? 'text-decoration: line-through; color: var(--v-primary-base)'
                  : 'text-decoration: line-through;'
                : hover
                ? 'color: var(--v-primary-base)'
                : ''
            "
          >
            {{ formatPrice((order.fairPayStatus === 'PAID' && order.status === 'noshow') || (order.fairPayStatus === 'PARDONED' && order.status !== 'cancelled') ? order.actualFee : order.total) }}
          </p>
        </div>
      </div>
    </v-hover>
    <hr
      :class="`profile__container--navigation__${
        layout == 'portal' ? 'portal-linebreak' : 'linebreak'
      }`"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    order: {
      required: true,
      type: Object,
      default: null,
    },
    description: {
      required: false,
      default: "",
      type: String,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data: () => ({
    test: null,
  }),
  computed: {
    icon() {
      if (!this.order.isProduct) {
        switch (true) {
          case ((this.order.status === "future-visit" && !this.order.isProductReservation) || this.isFutureButNotYetPaid) && !this.isCancelled:
            return "fxt-calendar";
          case this.order.status === "previous-visit":
            return "fxt-calendar-check";
          case (this.order.status === "cancelled" && !(this.order.fairPayStatus === 'PAID' && this.order.status === 'cancelled')) || this.isCancelled:
            return "fxt-cancel";
          case this.order.status === "product-purchase" || this.order.isProductReservation:
            return "fxt-dispenser";
          case this.order.status === "noshow" || (this.order.fairPayStatus === 'PAID' && this.order.status === 'cancelled'):
            return "fxt-calendar-off";
        }
      } else {
        return this.order.status === "Cancelled" ? "fxt-cancel" : "fxt-dispenser";
      }
    },
    iconColor() {
      return this.isCancelled || this.isCancelledNoShow ? 'error' : (this.order.status === "future-visit" && !this.order.isProductReservation) || ['noshow', 'cancelled'].includes(this.order.status) && this.order.fairPayStatus === 'NEW' && this.layout == 'portal' ? '#579fa7' : 'primary'
    },
    isFutureButNotYetPaid() { //For x timer siden
      return (['future-visit', 'noshow'].includes(this.order.status) && this.order.fairPayStatus === 'NEW')
    },
    isNormalNoshow() { //Ikke møtt til besøk
      return (this.order.status === 'noshow' && (!this.order.fairPayStatus || this.order.fairPayStatus === 'UNKNOWN'))
    },
    isPaidCancelFee() { //Ikke møtt til besøk
      return this.order.fairPayStatus === 'PAID' && ['cancelled'].includes(this.order.status);
    },
    isPaidNoShowFee() { //Ikke møtt gebyr
      return this.order.fairPayStatus === 'PAID' && ['noshow'].includes(this.order.status);
    },
    isPardoned() {
      return this.order.fairPayStatus === 'PARDONED'
    },
    isCancelled() { //Linethrough and red color
      return (['cancelled','Cancelled'].includes(this.order.status) && (!this.order.fairPayStatus || this.order.fairPayStatus === 'UNKNOWN')) || this.isPaidCancelFee || this.isNormalNoshow || this.isLateCancellation
    },
    isCancelledNoShow() { //Linethrough and red color
      return (['cancelled','Cancelled'].includes(this.order.status) && this.order.fairPayStatus === 'PARDONED')
    },
    isLateCancellation() {
      return this.order.fairPayStatus === 'NEW'  && ['cancelled'].includes(this.order.status)
    }
  },
  methods: {
    getDate(appointmentDate) {
      return new Date(appointmentDate).toLocaleDateString("no-NO", {
        year: "numeric",
        month: this.$vuetify.breakpoint.smAndDown ? "numeric" : "long",
        day: "numeric",
      });
    },
    formatPrice(price) {
      if (this.order.isProduct && this.order.status === "Credited") {
        return "-" + price.toFixed(2).replace(".", ",");
      }
      return price.toFixed(2).replace(".", ",");
    },
  },
};
</script>
